/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GitHubRepositoryCto } from '../../models/git-hub-repository-cto';

export interface GetRepositories$Plain$Params {
}

export function getRepositories$Plain(http: HttpClient, rootUrl: string, params?: GetRepositories$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GitHubRepositoryCto>>> {
  const rb = new RequestBuilder(rootUrl, getRepositories$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GitHubRepositoryCto>>;
    })
  );
}

getRepositories$Plain.PATH = '/api/v1/github/repositories';
